import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { faCubes } from "@fortawesome/free-solid-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { faCartArrowDown } from "@fortawesome/free-solid-svg-icons";

import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faStore } from "@fortawesome/free-solid-svg-icons";
import { faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import { faFileShield } from "@fortawesome/free-solid-svg-icons";
import { faListCheck } from "@fortawesome/free-solid-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faMagnifyingGlassChart } from "@fortawesome/free-solid-svg-icons";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";


export  const ClientPanelItems =   [
    // {
    //   label: "Dashboard",
    //   href:`/customerPortal/clientDashboard`,
    //    icon: faQrcode ,
    //   //  iconOnchange: faQrcode
    // },
    {
      label: "Shares",
      href:  `/customerPortal/myShares`,
       icon: faCubes ,
      //  iconOnchange: myShareChange,
       subItems : [ {
        label : "Buy Share",
        href : `/customerPortal/myShares/buyShares`,
        icon: faCartPlus
       },
       {
        label : "Sell Share",
        href : `/customerPortal/myShares/sellShares`,
        icon: faCartArrowDown
       }
    ]
    //   iconOnchange: dataIconChange
    },
    {
      label: "Support",
      href:  `/customerPortal/support`,
    icon: faHeadset,
    // iconOnchange: supportChange
    },
    {
      label: "Promo code",
      href:  `/customerPortal/promoCode`,
      icon: faGift ,
      // iconOnchange: promoCodeChange
    },
   
  ];


  export  const AdminPanelItems =   [
    {
      label: "Dashboard",
      href:`/admin/adminDashboard`,
       icon: faQrcode ,
      //  iconOnchange: dashboardIcon
    },
    {
      label: "User Management",
      href:  `/admin/userManagement`,
       icon: faUsers ,
      //  iconOnchange: profileIcon
    },
    {
      label: "Stores Management",
      href:  `/admin/storeManagement`,
       icon: faStore,
      //  iconOnchange: storeIcon
    },
    // {
    //   label: "Share Value",
    //   href:  `/admin/priceConfiguration`,
    // icon: faMoneyBillWave,
    // // iconOnchange: priceConfig
    // },
    {
      label: "Share Management",
      href:  `/admin/shareManagement`,
    icon: faMoneyBillWave,
    // iconOnchange: priceConfig
    },
    {
      label: "Reports",
      href:  `/admin/shareReports`,
       icon: faFileImage,
      //  iconOnchange: storeIcon
    },
    {
      label: "Order Request",
      href:  `/admin/orderRequest`,
      icon: faFolderOpen ,
      // iconOnchange: withdrawRequest
    },{
        label: "FAQ Management",
        href:  `/admin/dataManagement`,
        icon: faFileShield ,
        // iconOnchange: enquireIcon
      },
      {
        label: "Enquiries",
        href:  `/admin/enquiresList`,
        icon: faListCheck ,
        // iconOnchange: enquireIcon
      },
      {
        label: "Master Data",
        href:  `/admin/masterData`,
        icon: faDatabase ,
        // iconOnchange: enquireIcon
      },
      {
        label: "SEO",
        href:  `/admin/seoData`,
        icon: faMagnifyingGlassChart ,
        // iconOnchange: enquireIcon
      },
     
   
  ];